import { createFileRoute } from '@tanstack/react-router'
import CustomTag from '@/features/custom-tags'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { Permissions } from '@/constants/roles-permissions'

export const Route = createFileRoute('/_authenticated/custom-tag')({
  component: CustomTagRoute,
})

function CustomTagRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.CustomTagView}>
      <CustomTag />
    </ProtectedRoute>
  )
} 